import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Check if route is public
  if (authService.isPublicRoute(state.url)) {
    return true;
  }

  // Check if user is logged in
  if (authService.isLoggedIn()) {
    // Check roles if required
    const requiredRoles = route.data['roles'] as string[];
    if (requiredRoles && requiredRoles.length > 0) {
      const hasRole = requiredRoles.some(role => authService.hasRole(role));
      if (!hasRole) {
        router.navigate(['/unauthorized']);
        return false;
      }
    }
    return true;
  } else {
    authService.login();
    return false;
  }
};
